/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PayorSource
 */
export interface PayorSource {
    [key: string]: any | any;
    /**
     * 
     */
    payor_type: string;
    /**
     * 
     */
    payor_source?: string;
    /**
     * 
     */
    list_on_claim_as?: string;
    /**
     * 
     */
    additional_information_priority?: PayorSourceAdditionalInformationPriorityEnum;
    /**
     * 
     */
    hold_from_billing?: boolean;
    /**
     * 
     */
    poc_required?: boolean;
    /**
     * 
     */
    assignment_of_benefits?: boolean;
    /**
     * 
     */
    active?: boolean;
    /**
     * 
     */
    patient_is_in_an_hmo?: boolean;
    /**
     * 
     */
    generate_concurrent_workflow?: boolean;
    /**
     * 
     */
    generate_oasis_workflow?: boolean;
    /**
     * 
     */
    payor_code?: string;
    /**
     * 
     */
    secondary_identification?: string;
    /**
     * 
     */
    priority_of_admission_or_visit?: string;
    /**
     * 
     */
    point_of_origin?: string;
    /**
     * 
     */
    claim_benefit_date?: string;
    /**
     * 
     */
    covered_by_medicare?: boolean;
    /**
     * 
     */
    authorization_on_file?: boolean;
    /**
     * 
     */
    medicare_number?: string;
    /**
     * 
     */
    medicare_a_effective?: string;
    /**
     * 
     */
    medicare_b_effective?: string;
    /**
     * 
     */
    authorization_date?: string;
    /**
     * 
     */
    policy_number?: string;
    /**
     * 
     */
    medicaid_number?: string;
    /**
     * 
     */
    claim_number?: string;
    /**
     * 
     */
    medicaid_effective?: string;
    /**
     * 
     */
    patient_relationship_to_insured?: string;
    /**
     * 
     */
    insured_last_name?: string;
    /**
     * 
     */
    insured_first_name?: string;
    /**
     * 
     */
    insured_gender?: string;
    /**
     * 
     */
    insured_party_dob?: string;
    /**
     * 
     */
    insured_address?: string;
    /**
     * 
     */
    insured_zip_code?: string;
    /**
     * 
     */
    insured_city?: string;
    /**
     * 
     */
    insured_state?: string;
    /**
     * 
     */
    insured_phone?: string;
    /**
     * 
     */
    insured_email?: string;
    /**
     * 
     */
    employer_group_plan_number?: string;
    /**
     * 
     */
    employer_group_plan_name?: string;
    /**
     * 
     */
    employer_name?: string;
    /**
     * 
     */
    employer_address?: string;
    /**
     * 
     */
    employer_zip_code?: string;
    /**
     * 
     */
    employer_city?: string;
    /**
     * 
     */
    employer_state?: string;
    /**
     * 
     */
    employer_primary_phone?: string;
    /**
     * 
     */
    mbi?: string;
    /**
     * 
     */
    medicare_group_plan_number?: string;
    /**
     * 
     */
    medicare_policy_number?: string;
    /**
     * 
     */
    medicare_group_plan_name?: string;
    /**
     * 
     */
    medicare_medicaid_number?: string;
    /**
     * 
     */
    medicare_medicaid_effective?: string;
    /**
     * 
     */
    episode_timing?: string;
    /**
     * 
     */
    group_plan_number?: string;
    /**
     * 
     */
    group_plan_name?: string;
    /**
     * 
     */
    physician_medicaid_number?: string;
    /**
     * 
     */
    supply_billing?: string;
    /**
     * 
     */
    episode_length?: string;
}


/**
 * @export
 */
export const PayorSourceAdditionalInformationPriorityEnum = {
    Primary: 'PRIMARY',
    Secondary: 'SECONDARY',
    InformationalOnly: 'INFORMATIONAL ONLY',
} as const;
export type PayorSourceAdditionalInformationPriorityEnum = typeof PayorSourceAdditionalInformationPriorityEnum[keyof typeof PayorSourceAdditionalInformationPriorityEnum];


/**
 * Check if a given object implements the PayorSource interface.
 */
export function instanceOfPayorSource(value: object): value is PayorSource {
    if (!('payor_type' in value) || value['payor_type'] === undefined) return false;
    return true;
}

export function PayorSourceFromJSON(json: any): PayorSource {
    return PayorSourceFromJSONTyped(json, false);
}

export function PayorSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayorSource {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'payor_type': json['payor_type'],
        'payor_source': json['payor_source'] == null ? undefined : json['payor_source'],
        'list_on_claim_as': json['list_on_claim_as'] == null ? undefined : json['list_on_claim_as'],
        'additional_information_priority': json['additional_information_priority'] == null ? undefined : json['additional_information_priority'],
        'hold_from_billing': json['hold_from_billing'] == null ? undefined : json['hold_from_billing'],
        'poc_required': json['poc_required'] == null ? undefined : json['poc_required'],
        'assignment_of_benefits': json['assignment_of_benefits'] == null ? undefined : json['assignment_of_benefits'],
        'active': json['active'] == null ? undefined : json['active'],
        'patient_is_in_an_hmo': json['patient_is_in_an_hmo'] == null ? undefined : json['patient_is_in_an_hmo'],
        'generate_concurrent_workflow': json['generate_concurrent_workflow'] == null ? undefined : json['generate_concurrent_workflow'],
        'generate_oasis_workflow': json['generate_oasis_workflow'] == null ? undefined : json['generate_oasis_workflow'],
        'payor_code': json['payor_code'] == null ? undefined : json['payor_code'],
        'secondary_identification': json['secondary_identification'] == null ? undefined : json['secondary_identification'],
        'priority_of_admission_or_visit': json['priority_of_admission_or_visit'] == null ? undefined : json['priority_of_admission_or_visit'],
        'point_of_origin': json['point_of_origin'] == null ? undefined : json['point_of_origin'],
        'claim_benefit_date': json['claim_benefit_date'] == null ? undefined : json['claim_benefit_date'],
        'covered_by_medicare': json['covered_by_medicare'] == null ? undefined : json['covered_by_medicare'],
        'authorization_on_file': json['authorization_on_file'] == null ? undefined : json['authorization_on_file'],
        'medicare_number': json['medicare_number'] == null ? undefined : json['medicare_number'],
        'medicare_a_effective': json['medicare_a_effective'] == null ? undefined : json['medicare_a_effective'],
        'medicare_b_effective': json['medicare_b_effective'] == null ? undefined : json['medicare_b_effective'],
        'authorization_date': json['authorization_date'] == null ? undefined : json['authorization_date'],
        'policy_number': json['policy_number'] == null ? undefined : json['policy_number'],
        'medicaid_number': json['medicaid_number'] == null ? undefined : json['medicaid_number'],
        'claim_number': json['claim_number'] == null ? undefined : json['claim_number'],
        'medicaid_effective': json['medicaid_effective'] == null ? undefined : json['medicaid_effective'],
        'patient_relationship_to_insured': json['patient_relationship_to_insured'] == null ? undefined : json['patient_relationship_to_insured'],
        'insured_last_name': json['insured_last_name'] == null ? undefined : json['insured_last_name'],
        'insured_first_name': json['insured_first_name'] == null ? undefined : json['insured_first_name'],
        'insured_gender': json['insured_gender'] == null ? undefined : json['insured_gender'],
        'insured_party_dob': json['insured_party_dob'] == null ? undefined : json['insured_party_dob'],
        'insured_address': json['insured_address'] == null ? undefined : json['insured_address'],
        'insured_zip_code': json['insured_zip_code'] == null ? undefined : json['insured_zip_code'],
        'insured_city': json['insured_city'] == null ? undefined : json['insured_city'],
        'insured_state': json['insured_state'] == null ? undefined : json['insured_state'],
        'insured_phone': json['insured_phone'] == null ? undefined : json['insured_phone'],
        'insured_email': json['insured_email'] == null ? undefined : json['insured_email'],
        'employer_group_plan_number': json['employer_group_plan_number'] == null ? undefined : json['employer_group_plan_number'],
        'employer_group_plan_name': json['employer_group_plan_name'] == null ? undefined : json['employer_group_plan_name'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_address': json['employer_address'] == null ? undefined : json['employer_address'],
        'employer_zip_code': json['employer_zip_code'] == null ? undefined : json['employer_zip_code'],
        'employer_city': json['employer_city'] == null ? undefined : json['employer_city'],
        'employer_state': json['employer_state'] == null ? undefined : json['employer_state'],
        'employer_primary_phone': json['employer_primary_phone'] == null ? undefined : json['employer_primary_phone'],
        'mbi': json['mbi'] == null ? undefined : json['mbi'],
        'medicare_group_plan_number': json['medicare_group_plan_number'] == null ? undefined : json['medicare_group_plan_number'],
        'medicare_policy_number': json['medicare_policy_number'] == null ? undefined : json['medicare_policy_number'],
        'medicare_group_plan_name': json['medicare_group_plan_name'] == null ? undefined : json['medicare_group_plan_name'],
        'medicare_medicaid_number': json['medicare_medicaid_number'] == null ? undefined : json['medicare_medicaid_number'],
        'medicare_medicaid_effective': json['medicare_medicaid_effective'] == null ? undefined : json['medicare_medicaid_effective'],
        'episode_timing': json['episode_timing'] == null ? undefined : json['episode_timing'],
        'group_plan_number': json['group_plan_number'] == null ? undefined : json['group_plan_number'],
        'group_plan_name': json['group_plan_name'] == null ? undefined : json['group_plan_name'],
        'physician_medicaid_number': json['physician_medicaid_number'] == null ? undefined : json['physician_medicaid_number'],
        'supply_billing': json['supply_billing'] == null ? undefined : json['supply_billing'],
        'episode_length': json['episode_length'] == null ? undefined : json['episode_length'],
    };
}

export function PayorSourceToJSON(json: any): PayorSource {
    return PayorSourceToJSONTyped(json, false);
}

export function PayorSourceToJSONTyped(value?: PayorSource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'payor_type': value['payor_type'],
        'payor_source': value['payor_source'],
        'list_on_claim_as': value['list_on_claim_as'],
        'additional_information_priority': value['additional_information_priority'],
        'hold_from_billing': value['hold_from_billing'],
        'poc_required': value['poc_required'],
        'assignment_of_benefits': value['assignment_of_benefits'],
        'active': value['active'],
        'patient_is_in_an_hmo': value['patient_is_in_an_hmo'],
        'generate_concurrent_workflow': value['generate_concurrent_workflow'],
        'generate_oasis_workflow': value['generate_oasis_workflow'],
        'payor_code': value['payor_code'],
        'secondary_identification': value['secondary_identification'],
        'priority_of_admission_or_visit': value['priority_of_admission_or_visit'],
        'point_of_origin': value['point_of_origin'],
        'claim_benefit_date': value['claim_benefit_date'],
        'covered_by_medicare': value['covered_by_medicare'],
        'authorization_on_file': value['authorization_on_file'],
        'medicare_number': value['medicare_number'],
        'medicare_a_effective': value['medicare_a_effective'],
        'medicare_b_effective': value['medicare_b_effective'],
        'authorization_date': value['authorization_date'],
        'policy_number': value['policy_number'],
        'medicaid_number': value['medicaid_number'],
        'claim_number': value['claim_number'],
        'medicaid_effective': value['medicaid_effective'],
        'patient_relationship_to_insured': value['patient_relationship_to_insured'],
        'insured_last_name': value['insured_last_name'],
        'insured_first_name': value['insured_first_name'],
        'insured_gender': value['insured_gender'],
        'insured_party_dob': value['insured_party_dob'],
        'insured_address': value['insured_address'],
        'insured_zip_code': value['insured_zip_code'],
        'insured_city': value['insured_city'],
        'insured_state': value['insured_state'],
        'insured_phone': value['insured_phone'],
        'insured_email': value['insured_email'],
        'employer_group_plan_number': value['employer_group_plan_number'],
        'employer_group_plan_name': value['employer_group_plan_name'],
        'employer_name': value['employer_name'],
        'employer_address': value['employer_address'],
        'employer_zip_code': value['employer_zip_code'],
        'employer_city': value['employer_city'],
        'employer_state': value['employer_state'],
        'employer_primary_phone': value['employer_primary_phone'],
        'mbi': value['mbi'],
        'medicare_group_plan_number': value['medicare_group_plan_number'],
        'medicare_policy_number': value['medicare_policy_number'],
        'medicare_group_plan_name': value['medicare_group_plan_name'],
        'medicare_medicaid_number': value['medicare_medicaid_number'],
        'medicare_medicaid_effective': value['medicare_medicaid_effective'],
        'episode_timing': value['episode_timing'],
        'group_plan_number': value['group_plan_number'],
        'group_plan_name': value['group_plan_name'],
        'physician_medicaid_number': value['physician_medicaid_number'],
        'supply_billing': value['supply_billing'],
        'episode_length': value['episode_length'],
    };
}

